if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.launchTime = new Date(this.dataset.launchDate).getTime();
      this.nowTime    = Date.now();
      if (this.launchTime > this.nowTime) {
      this.render();
      this.start();
      }
    }

    start() {
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const now = Date.now();
      const diff = this.launchTime - now;

      if (diff <= 0) {
        clearInterval(this.interval);
        window.location.reload();
        return;
      }

      const time = this.parse(diff);
      this.updateUnit('days', time.days);
      this.updateUnit('hours', time.hours);
      this.updateUnit('minutes', time.minutes);
      this.updateUnit('seconds', time.seconds);

      this.setAttribute(
        'aria-label',
        `Countdown timer: ${time.days}:${time.hours}:${time.minutes}:${time.seconds}`
      );
    }

    parse(ms) {
      return {
        days: Math.floor(ms / 86400000),
        hours: Math.floor((ms % 86400000) / 3600000),
        minutes: Math.floor((ms % 3600000) / 60000),
        seconds: Math.floor((ms % 60000) / 1000)
      };
    }

    updateUnit(name, value) {
      const tens = Math.floor(value / 10);
      const ones = value % 10;

      const unit = this.querySelector(`[data-unit="${name}"]`);
      this.updateDigit(unit.querySelector('[data-digit="tens"]'), tens);
      this.updateDigit(unit.querySelector('[data-digit="ones"]'), ones);
    }

    updateDigit(container, number) {
      container.querySelectorAll('[data-number]').forEach(el => {
        const visible = Number(el.dataset.number) === number;
        el.dataset.visible = visible ? 'true' : 'false';
        el.style.opacity = visible ? '1' : '0';
        el.style.transform = visible
          ? 'translateY(0)'
          : 'translateY(50%)';
      });
    }

    render() {
      this.innerHTML = `
        <div class="countdown" role="timer">
          ${this.unit('days', 'Days')}
          ${this.separator()}
          ${this.unit('hours', 'Hours')}
          ${this.separator()}
          ${this.unit('minutes', 'Minutes')}
          ${this.separator()}
          ${this.unit('seconds', 'Seconds')}
        </div>
      `;
    }

    separator() {
      return `<span class="countdown__separator">:</span>`;
    }

    unit(key, label) {
      return `
        <div class="countdown__unit" data-unit="${key}">
          <div class="countdown__digits">
            ${this.digit('tens')}
            ${this.digit('ones', true)}
          </div>
          <p class="countdown__label">${label}</p>
        </div>
      `;
    }

    digit(position, offset = false) {
      return `
        <div class="countdown__digit ${offset ? 'is-offset' : ''}" data-digit="${position}">
          ${[...Array(10)].map((_, i) => `
            <div
              data-number="${i}"
              class="countdown__number"
              aria-hidden="true"
            >${i}</div>
          `).join('')}
        </div>
      `;
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}

// simple text component that shows the launch date in "MMM DD" form
if (!customElements.get('countdown-text')) {
  class CountdownText extends HTMLElement {
    connectedCallback() {
      const date = new Date(this.dataset.launchDate);
      this.launchTime = new Date(this.dataset.launchDate).getTime();
      this.nowTime    = Date.now();
      if (this.launchTime > this.nowTime) {
        if (!isNaN(date)) {
          const opts = { month: 'short', day: 'numeric' };
          this.textContent = date.toLocaleDateString('en-US', opts).toUpperCase();
        }
      }
    }
  }
  customElements.define('countdown-text', CountdownText);
}

class BadgeInner extends HTMLElement {
  connectedCallback() {
      console.log('launchDate:', this.dataset.launchDate);

    const launchDate = this.dataset.launchDate;

    if (!launchDate) return;

    this.launchTime = new Date(launchDate).getTime();
    this.nowTime = Date.now();

    if (this.launchTime > this.nowTime) {
      this.render();
      this.start(); 
    } else {
      this.innerHTML = '';
    }
  }

  render() {
    this.innerHTML = `
      <span class="badge-inner coming-soon">
        Coming soon
      </span>
    `;
  }

  start() {
    this.interval = setInterval(() => {
      const now = Date.now();

      if (now >= this.launchTime) {
        this.innerHTML = '';
        clearInterval(this.interval);
      }
    }, 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

customElements.define('badge-inner', BadgeInner);